import {Livewire} from '../../vendor/livewire/livewire/dist/livewire.esm';

import Flatpickr from 'flatpickr';
import dayjs from 'dayjs';
import currency from 'currency.js';

import './alpine';

window.dayjs = dayjs;
window.Flatpickr = Flatpickr;
window.currency = currency;

Livewire.start();
